import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid2,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import Header from "../../components/Header";
import { Cancel, Close, FileDownload, VerifiedUser } from "@mui/icons-material";
import { useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import format from "date-fns/format";
const JobInvoiceDialog = ({
  isNonMobile,
  handleCloseInvoice,
  open,
  data,
  type,
}) => {
  // console.log("data", data);
  const printRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const handleDownloadPdf = async (docNumber) => {
    setLoading(true);
    const element = printRef.current;
    if (!element) {
      return;
    }

    const canvas = await html2canvas(element, {
      scale: 2,
    });
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: "a4",
    });

    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();

    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    pdf.addImage(data, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${type}_${docNumber}.pdf`);
    setLoading(false);
  };
  return (
    <div>
      <Dialog
        open={open}
        maxWidth="lg"
        onClose={handleCloseInvoice}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box display="flex" gap={2}>
              <Header
                title={
                  type === "INVOICE" ? "Job Request Invoice" : "Job Quotation"
                }
              />
              <Typography variant="h4" alignContent="center" color="success">
                Job{" "}
                {data?.year + "/" + String(data?.autoIdByYear).padStart(4, "0")}
              </Typography>
            </Box>
            <IconButton onClick={handleCloseInvoice} aria-label="delete">
              <Close color="error" />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Paper
            ref={printRef}
            sx={{
              width: "70%",
              padding: "10px",
              borderRadius: "8px",
              marginBottom: "15px",
              width: "210mm",
              padding: "45px 25px 20px 25px",
            }}
            elevation={3}
          >
            <Box
              sx={{
                marginTop: "15px",
                marginBottom: "15px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box display="flex" flexDirection="column-reverse">
                <img
                  alt="gove-logo"
                  width="80px"
                  height="100px"
                  style={{ cursor: "pointer" }}
                  src={`../../assets/Gove.png`}
                />
              </Box>
              <Grid2
                container
                display={"block"}
                alignContent="center"
                justifyItems="baseline"
                textAlign={"right"}
              >
                <Typography
                  variant="h2"
                  color="success"
                  alignContent="center"
                  sx={{ fontWeight: 700 }}
                >
                  {type}
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 700 }}>
                  MATERIAL TESTING LABORATORY - KEKIRAWA
                </Typography>
                <Typography variant="h5">
                  PROVINCIAL ENGINEERING DEPARTMENT - NORTH CENTRAL PROVINCE
                </Typography>
                <Typography variant="h5">
                  Email : support@matlab.lk | Tel : 025 2263285 | Fax : 025
                  2265490
                </Typography>
              </Grid2>
              <Box display="flex" flexDirection="column-reverse">
                <img
                  alt="gove-logo"
                  width="120px"
                  height="70px"
                  style={{ cursor: "pointer" }}
                  src={`../../assets/ncp.png`}
                />
              </Box>
            </Box>
            <Divider sx={{ marginBottom: "15px" }} />
            <Box sx={{ marginTop: "15px" }}>
              <Grid2 container spacing={1}>
                <Grid2 size={5}>
                  <Paper elevation={2} sx={{ padding: "10px", height: "100%" }}>
                    <Grid2 container spacing={1}>
                      <Grid2 size={4}>
                        <Box
                          display="flex"
                          alignItems="center"
                          columnGap="10px"
                        >
                          <Typography variant="h5" sx={{ fontWeight: 700 }}>
                            {type === "INVOICE" ? "Invoice No" : "QT No"}
                          </Typography>
                        </Box>
                      </Grid2>
                      <Grid2 size={1}>
                        <Typography
                          variant="h5"
                          component="h2"
                          sx={{ fontWeight: 700 }}
                        >
                          :
                        </Typography>
                      </Grid2>
                      <Grid2 size={7}>
                        <Typography variant="h5" component="h2">
                          {data?.labRequestInvoice
                            ? data.year +
                              "/" +
                              String(data.autoIdByYear).padStart(4, "0") +
                              (type === "INVOICE" ? "/INV" : "/QT") +
                              String(data.autoIdByYear).padStart(3, "0")
                            : ""}
                        </Typography>
                      </Grid2>

                      <Grid2 size={4}>
                        <Box
                          display="flex"
                          alignItems="center"
                          columnGap="10px"
                        >
                          <Typography variant="h5" sx={{ fontWeight: 700 }}>
                            {type === "INVOICE" ? "Invoice Date" : "QT. Date"}
                          </Typography>
                        </Box>
                      </Grid2>
                      <Grid2 size={1}>
                        <Typography
                          variant="h5"
                          component="h2"
                          sx={{ fontWeight: 700 }}
                        >
                          :
                        </Typography>
                      </Grid2>
                      <Grid2 size={7}>
                        <Typography variant="h5" component="h2">
                          {data?.regDate}
                        </Typography>
                      </Grid2>
                      <Grid2 size={4}>
                        <Box
                          display="flex"
                          alignItems="center"
                          columnGap="10px"
                        >
                          <Typography variant="h5" sx={{ fontWeight: 700 }}>
                            Job No
                          </Typography>
                        </Box>
                      </Grid2>
                      <Grid2 size={1}>
                        <Typography
                          variant="h5"
                          component="h2"
                          sx={{ fontWeight: 700 }}
                        >
                          :
                        </Typography>
                      </Grid2>
                      <Grid2 size={7}>
                        <Typography variant="h5" component="h2">
                          {data?.year +
                            "/" +
                            String(data?.autoIdByYear).padStart(4, "0")}
                        </Typography>
                      </Grid2>
                    </Grid2>
                  </Paper>
                </Grid2>
                <Grid2 size={7}>
                  <Paper elevation={2} sx={{ padding: "10px", height: "100%" }}>
                    <Grid2 container spacing={1} textAlign={"right"}>
                      <Grid2 size={12}>
                        <Typography variant="h4">{type} TO</Typography>
                      </Grid2>
                      {/* <TextSnippet sx={{ color: colors.greenAccent[500] }} /> */}
                      <Grid2 size={12}>
                        <Typography variant="h5">
                          {data?.institute ? data?.institute.instituteName : ""}
                        </Typography>
                      </Grid2>

                      <Grid2 size={12}>
                        <Typography variant="h5" component="h2">
                          {data?.institute
                            ? data?.institute.address1 +
                              " " +
                              data?.institute.address2 +
                              " " +
                              data?.institute.city
                            : ""}
                        </Typography>
                      </Grid2>
                    </Grid2>
                  </Paper>
                </Grid2>
              </Grid2>
            </Box>
            <Divider sx={{ marginBottom: "15px", marginTop: "15px" }} />
            <Box
              display="grid"
              gap="8px"
              gridTemplateColumns="repeat(12, minmax(0, 1fr))"
              sx={{
                "& > div": {
                  gridColumn: isNonMobile ? undefined : "span 12",
                },
              }}
            >
              <Typography sx={{ gridColumn: "span 12" }} variant="h4">
                Project
              </Typography>
              <Typography sx={{ gridColumn: "span 12" }} variant="h5">
                {data?.project}
              </Typography>
              <Divider sx={{ gridColumn: "span 12" }} />

              <Typography
                textAlign="center"
                variant="h5"
                alignContent="center"
                sx={{
                  gridColumn: "span 5",
                  marginTop: "8px",
                  fontWeight: 800,
                }}
              >
                Test Name
              </Typography>
              <Typography
                textAlign="end"
                variant="h5"
                alignContent="center"
                sx={{
                  gridColumn: "span 2",
                  marginTop: "8px",
                  fontWeight: 800,
                }}
              >
                Rate (Rs.)
              </Typography>
              <Typography
                textAlign="right"
                variant="h5"
                alignContent="flex-end"
                sx={{
                  gridColumn: "span 2",
                  marginTop: "8px",
                  fontWeight: 800,
                }}
              >
                Quantity
              </Typography>
              <Typography
                textAlign="right"
                variant="h5"
                alignContent="center"
                sx={{
                  gridColumn: "span 2",
                  marginTop: "8px",
                  fontWeight: 800,
                }}
              >
                Total
              </Typography>
            </Box>
            <Divider sx={{ margin: "10px 0 10px 0" }}></Divider>{" "}
            {data?.labRequestTests?.map((data, index) => (
              <Box
                key={index}
                display="grid"
                gap="8px"
                gridTemplateColumns="repeat(12, minmax(0, 1fr))"
                sx={{
                  "& > div": {
                    gridColumn: isNonMobile ? undefined : "span 12",
                  },
                }}
              >
                <Typography
                  textAlign="left"
                  variant="h5"
                  alignContent="center"
                  sx={{
                    gridColumn: "span 6",
                    marginTop: "8px",
                  }}
                >
                  {`${index + 1}. ${data.labTest?.testName}`}
                </Typography>
                <Typography
                  textAlign="center"
                  variant="h5"
                  alignContent="center"
                  sx={{
                    gridColumn: "span 2",
                    marginTop: "8px",
                  }}
                >
                  {data.labTest?.amount.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
                </Typography>
                <Typography
                  textAlign="center"
                  variant="h5"
                  alignContent="center"
                  sx={{
                    gridColumn: "span 2",
                    marginTop: "8px",
                  }}
                >
                  {data.quantity.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
                </Typography>
                <Typography
                  textAlign="center"
                  variant="h5"
                  alignContent="center"
                  sx={{
                    gridColumn: "span 2",
                    marginTop: "8px",
                  }}
                >
                  {data.total.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
                </Typography>

                {data.labTest?.testName.startsWith("Transport cost") ? (
                  ""
                ) : (
                  <Box
                    sx={{
                      gridColumn: "span 12",
                    }}
                  >
                    <Typography variant="subtitle1" color="info">
                      Report collect method : {data.reportCollectMethod}
                    </Typography>
                  </Box>
                )}
              </Box>
            ))}
            <Divider sx={{ margin: "15px 0 15px 0" }}></Divider>
            <Box
              display="grid"
              gap="8px"
              width="100%"
              gridTemplateColumns="repeat(3, minmax(0, 1fr))"
            >
              <Typography
                textAlign="right"
                variant="h3"
                alignContent="center"
                sx={{
                  gridColumn: "span 2",
                  marginTop: "2px",
                }}
              >
                TOTAL AMOUNT
              </Typography>
              <Typography
                textAlign="right"
                variant="h3"
                alignContent="center"
                sx={{
                  gridColumn: "span 1",
                  marginTop: "2px",
                }}
              >
                LKR{" "}
                {data?.grandTotal?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                })}
              </Typography>

              {type === "INVOICE" ? (
                <Typography
                  textAlign="right"
                  variant="h3"
                  color="success"
                  alignContent="center"
                  sx={{
                    gridColumn: "span 2",
                    marginTop: "2px",
                  }}
                >
                  PAYMENT RECEIVED
                </Typography>
              ) : (
                ""
              )}

              {type === "INVOICE" ? (
                <Typography
                  color="success"
                  textAlign="right"
                  variant="h3"
                  alignContent="center"
                  sx={{
                    gridColumn: "span 1",
                    marginTop: "2px",
                  }}
                >
                  LKR{" "}
                  {(data?.grandTotal - data?.balance)?.toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                    },
                  )}
                </Typography>
              ) : (
                ""
              )}

              {data?.balance ? (
                <>
                  <Typography
                    textAlign="right"
                    color="error"
                    variant="h3"
                    alignContent="center"
                    sx={{
                      gridColumn: "span 2",
                      marginTop: "2px",
                    }}
                  >
                    DUE AMOUNT
                  </Typography>
                  <Typography
                    color="error"
                    textAlign="right"
                    variant="h3"
                    alignContent="center"
                    sx={{
                      gridColumn: "span 1",
                      marginTop: "2px",
                    }}
                  >
                    LKR{" "}
                    {data?.balance?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                    })}
                  </Typography>
                </>
              ) : (
                ""
              )}

              <Divider
                sx={{ margin: "2px 0 2px 0", gridColumn: "span 3" }}
              ></Divider>
              <Box sx={{ width: "750px" }}>
                <Grid2 container spacing={1}>
                  {type !== "INVOICE" ? (
                    <Grid2 size={6}>
                      <Box>
                        <Typography variant="h4">Bank Details</Typography>
                        <Typography variant="h5">BOC - Kekirawa</Typography>
                        <Typography variant="h5">
                          Account No - 71919535
                        </Typography>
                        <Typography variant="h5">Engineer</Typography>
                        <Typography variant="h5">
                          Quality Control Unit
                        </Typography>
                        <Typography variant="h5">Kekirawa</Typography>
                      </Box>
                    </Grid2>
                  ) : (
                    ""
                  )}

                  {type !== "INVOICE" ? (
                    ""
                  ) : (
                    <Grid2 size={12}>
                      <Box
                        height="100%"
                        alignContent="center"
                        justifyItems="center"
                        flexDirection="row"
                      >
                        {data?.paid === true ? (
                          <Box
                            alignItems="center"
                            display="flex"
                            flexDirection="column"
                          >
                            <VerifiedUser color="success" fontSize="large" />
                            <Typography variant="h1" color="success">
                              PAID
                            </Typography>
                          </Box>
                        ) : (
                          <Box
                            alignItems="center"
                            display="flex"
                            flexDirection="column"
                          >
                            <Cancel color="error" fontSize="large" />
                            <Typography variant="h1" color="error">
                              UNPAID
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </Grid2>
                  )}
                </Grid2>
                <Divider
                  sx={{ margin: "2px 0 2px 0", gridColumn: "span 3" }}
                ></Divider>
                <Typography
                  variant="subtitle1"
                  textAlign="center"
                  sx={{ marginTop: "10px" }}
                  color="success"
                >
                  THIS IS A COMPUTER GENERATED DOCUMENT NO SIGNATURE REQUIRED.
                </Typography>
                <Typography variant="body2" textAlign="center" color="info">
                  {type} GENERATED ON{" "}
                  {format(new Date(), "MMMM dd, yyyy hh:mm:ss a")}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </DialogContent>
        <Divider />
        <DialogActions sx={{ paddingRight: "25px" }}>
          <Button
            variant="contained"
            color="secondary"
            autoFocus
            loading={loading}
            startIcon={<FileDownload />}
            onClick={() =>
              handleDownloadPdf(
                data?.year + "/" + String(data?.id).padStart(4, "0"),
              )
            }
            size="medium"
          >
            DOWNLOAD PDF
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default JobInvoiceDialog;
